
import { Component, Prop, Vue } from 'vue-property-decorator'

import DeliveryAddressList from './DeliveryAddressList.vue'
import { EnrollmentForm } from '../types/enrollmentForm'

@Component({
  name: 'StepBankCards',
  components: { DeliveryAddressList }
})
export default class extends Vue {
  @Prop({ required: true }) form!: EnrollmentForm

  get showPhysicalAddresses(): boolean {
    return this.form.wantsPhysicalCards && this.form.deliveryAddresses.length === 0
  }
}
